import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";
import { BUTTON_SIZE, PrimaryButton } from "components/Buttons";
import { useAuth, useLinks } from "hooks";

/**
 * TeamAddButton
 *
 * @param {String}      style
 */
const BookMeetingButton = ({ style }) => {
  const { isShowcase } = useAuth();
  const navigate = useNavigate();
  const links = useLinks();

  const handleClick = (event) => {
    event.stopPropagation();
    navigate(links.book_meeting_link);
  };

  if (!isShowcase) return null;

  return (
    <PrimaryButton
      variant="orangeCountyBase"
      css={[styles.button, style]}
      size={BUTTON_SIZE.medium}
      onClick={handleClick}
    >
      <FormattedMessage id={"Banner.BannerShowcaseBookMeeting.CTA"} />
    </PrimaryButton>
  );
};

const styles = {
  button: css`
    width: 100%;
  `,
};

BookMeetingButton.propTypes = {
  style: PropTypes.object,
};

export default BookMeetingButton;
